import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface BallMarkProps {
    className?: string
}

/** Flat pickleball mark used in the logo and as a list bullet. */
export const BallMark: FC<BallMarkProps> = ({ className }): ReactNode => {
    return (
        <svg viewBox='0 0 64 64' aria-hidden='true' className={cn('shrink-0', className)}>
            <circle cx='32' cy='32' r='30' fill='#d6f04a' />
            <circle cx='32' cy='32' r='29' fill='none' stroke='#9fb82a' strokeWidth='2' />
            <g fill='#0d1433' fillOpacity='0.82'>
                <circle cx='32' cy='15' r='4.2' />
                <circle cx='18' cy='23' r='4' />
                <circle cx='46' cy='23' r='4' />
                <circle cx='32' cy='32' r='4.6' />
                <circle cx='17' cy='39' r='4' />
                <circle cx='47' cy='39' r='4' />
                <circle cx='25' cy='50' r='3.8' />
                <circle cx='39' cy='50' r='3.8' />
            </g>
        </svg>
    )
}
